import { Evaluation } from '@program/shared/evaluation/evaluation.model';
import { EvaluationQuestionType } from '@program/program-detail/program-configuration/shared/evaluation-config/evaluation-question-type.enum';
import { PASS_FAIL } from '@program/shared/evaluation/pass-fail.enum';
import { Total } from '@program/shared/evaluations-admin-all/evaluation-display/totals-type';

export function calculateTotals(evaluations: Evaluation[]): Total {
  return evaluations.reduce((accum, evaluation) => {
    if (evaluation.evaluationConfig.type === EvaluationQuestionType.PASS_FAIL) {
      if (evaluation.boolValue !== null) {
        if (evaluation.boolValue === true && accum.passFail !== PASS_FAIL.FAIL) {
          accum.passFail = PASS_FAIL.PASS;
        }
        if (evaluation.boolValue === false) {
          accum.passFail = PASS_FAIL.FAIL;
        }
      }
    }
    if (evaluation.evaluationConfig.type === EvaluationQuestionType.SCORE) {
      if (evaluation.scoreValue !== null && evaluation.scoreValue !== undefined) {
        accum.totalScore += ((evaluation.scoreValue / evaluation.evaluationConfig.rangeEnd) * evaluation.evaluationConfig.weight);
      }
    }
    return accum;
  }, {  passFail: null, totalScore: 0 });
}
